// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__34Bsl","inner":"Footer_inner__2s1WR"};